import { indexItems } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            影视合集
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-lg mx-auto">
            按类型快速找到你想看的国产影视内容，每日更新推荐
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4 md:gap-5">
          {indexItems.map((item) => (
            <a
              key={item.id}
              href="#carousel"
              className="group flex flex-col items-center p-5 md:p-6 bg-background-100 hover:bg-primary-50 rounded-xl border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center bg-primary-100 rounded-xl text-primary-600 group-hover:bg-primary-500 group-hover:text-white transition-all duration-200">
                <i className={`${item.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="mt-3 text-sm md:text-base font-semibold text-foreground-900 whitespace-nowrap">{item.title}</h3>
              <span className="mt-1 text-xs text-primary-600 font-medium whitespace-nowrap">{item.count}</span>
              <p className="mt-1 text-xs text-foreground-500 text-center leading-relaxed">{item.desc}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}